import {
    InitClient,
    GetByParas,
    Post,
    PostWithParas,
    PostNoParas
} from "../ZeusAPIClient.js";


//获取薪级列表
async function GetSalaryList(pid, p, pageSize, title) {
    var data = {
        pid: pid,
        p: p,
        pageSize: pageSize,
        title: title    
    };
     return await Post("d32945bd-89b6-4bb0-9f06-15b5b25ed30d", data);
   // return await PostWithParas("d32945bd-89b6-4bb0-9f06-15b5b25ed30d","", data);
}


//删除薪级列表
async function DeleteSysitem(userCode,ids) {    
    
    var para={userCode:userCode};
    return await PostWithParas("20d66aac-fd5a-4148-82d6-e0be400de83b",para, ids);
}

//删除SalaryInfo列表
async function DeleteSalaryInfo(userCode,ids) {    
    
    var para={userCode:userCode};
    return await PostWithParas("f0a004d3-20cf-42e8-9ac1-207786b89489",para, ids);
}

async function GetSingleSysItem(id)
{
    var paras={id:id};
    return await GetByParas("ea6daf4f-1d99-458c-9b4b-c4134976f988",paras);
}
//获取下一个排序
async function GetSingleSysItemSort(ParentId)
{
    var paras={ParentId:ParentId};
    return await GetByParas("d8f50e60-8575-4a5a-828c-c6c38400e7c2",paras);
}
//新增编辑，添加
async function AddSysItem(data)
{  
    return await Post("e5bc9b0b-c07b-48f9-807b-4d2231206b2d",data);
}


//根据父编号获取子项
async function GetSysItemListByParentID(ParentId)
{
    var paras={ParentId:ParentId};
    return await GetByParas("0b64639c-d28d-4baa-b1fa-d50c0606a3c1",paras);
}


//获取薪酬管理展示列表
async function GetSalaryInfoList(p,pageSize,TypeId,RankID,LevelID)
{  

    var data = {      
        p: p,
        pageSize: pageSize,
        TypeId: TypeId, 
        RankID: RankID,    
        LevelID: LevelID   
    };
    return await Post("1e31fe04-a604-44d4-8d0b-43bf6ec68650",data);
}

//新增
async function AddSalaryInfo(data)
{  

    
    return await Post("734079f2-a15c-452e-a55c-d460fd68e393",data);
}


//根据单个数据
async function GetSingleSalaryInfo(id)
{
    
    var paras={id:id};
    return await GetByParas("33df842e-9f1a-443b-98e7-eb4ebbf87e03",paras);
}


//获取薪资结构展示列表
async function GetFixedPerformanceList(p,pageSize,TypeId)
{  

    var data = {      
        p: p,
        pageSize: pageSize,
        Type: TypeId
       
    };
    console.log(data);
    return await Post("5cc35395-14e1-4726-bb25-461750b6d150",data);
}
//根据单个数据
async function GetSingleFixedPerformance(id)
{ 
    var paras={id:id};
    return await GetByParas("f939f399-b81b-4b73-aadd-075ae2aa21fe",paras);  
}
//新增FixedPerformance
async function AddFixedPerformance(data)
{    
     return await Post("823e378e-5919-47a6-a641-a095a796fca0",data);   
    //return await PostWithParas("823e378e-5919-47a6-a641-a095a796fca0","", data);
}
//删除FixedPerformance
async function DeleteFixedPerformance(userCode,ids) {    
    
    var para={userCode:userCode};
    return await PostWithParas("20d66aac-fd5a-4148-82d6-e0be400de83b",para, ids);
}
//获取岗位部门
async function GetFrameDutyList(name) {
   
     return await Post("c20cd697-2f32-48a5-a6a1-0a56e09b466d", name);
}
//删除部门下岗位
async function DeleteDuty(data)
{   
    return await Post("871fdde4-3d71-4a40-86e1-68d2e1928670",data);
}


//添加部门下岗位
async function SaveFrameDuty(data)
{ 
    return await Post("0b20d9ae-d8d7-4111-93e6-a213dc0f3363",data);
}
export{
    GetSalaryList,
    DeleteSysitem,
    GetSingleSysItem,
    GetSingleSysItemSort,
    AddSysItem,
    GetSysItemListByParentID,
    GetSalaryInfoList,
    AddSalaryInfo,
    GetSingleSalaryInfo,
    DeleteSalaryInfo,
    GetFixedPerformanceList,
    GetSingleFixedPerformance,
    AddFixedPerformance,
    DeleteFixedPerformance,
    GetFrameDutyList,
    DeleteDuty,
    SaveFrameDuty
}